module.exports = __webpack_public_path__ + "static/media/top_logo1.d558c401.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/top_logo1.png
// module id = 335
// module chunks = 0